import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Instagram } from "lucide-react";
import "./Footer.css";
import PMLogo from "../../assets/punjimitra-icon-2.png";

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <h4>
              <img src={PMLogo} alt="" className="footer-logo" />
              Poonji Mitra
            </h4>
            <p>
              India&apos;s complete financial ecosystem — portfolio management,
              wealth products, business finance, and insurance under one roof.
            </p>
          </div>

          <div className="footer-column">
            <h4>Invest</h4>
            <ul>
              <li>
                <Link to="/mutual-funds">Mutual Funds</Link>
              </li>
              <li>
                <Link to="/bonds">Bonds</Link>
              </li>
              <li>
                <Link to="/unlisted-shares">Unlisted Shares</Link>
              </li>
              <li>
                <Link to="/ipo-advisory">IPO Advisory</Link>
              </li>
              <li>
                <Link to="/algo-trading">Algo Trading</Link>
              </li>
              <li>
                <Link to="/insurance">Insurance</Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Platform</h4>
            <ul>
              <li>
                <Link to="/about">About</Link>
              </li>
              <li>
                <Link to="/services">Services</Link>
              </li>
              <li>
                <Link to="/portfolio-review">Portfolio Review</Link>
              </li>
              <li>
                <Link to="/calculators">Calculators</Link>
              </li>
              <li>
                <Link to="/strategies">Strategies</Link>
              </li>
              <li>
                <Link to="/business-services">Business Solutions</Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              <li>
                <Link to="/team">Team</Link>
              </li>
              <li>
                <Link to="/learning-centre">Learning Centre</Link>
              </li>
              <li>
                <Link to="/blogs">Blogs</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
              <li>
                <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Poonji Mitra. All rights reserved.</p>
          <div className="footer-social">
            <a
              href="https://www.linkedin.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <Linkedin size={18} />
            </a>
            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <Instagram size={18} />
            </a>
          </div>
        </div>

        <p className="footer-disclaimer">
          Mutual fund investments are subject to market risks. Read all
          scheme-related documents carefully. Past performance is not indicative
          of future results. Poonji Mitra provides advisory and distribution
          services; returns are not guaranteed. AMFI registration does not
          guarantee performance.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
